export enum RequestStatus {
  NOT_LOADED,
  LOADING,
  LOADED,
  ERROR,
}

export enum TransactionsStatus {
  COMPLETED = "Completed",
  PENDING = "Pending",
  PROCESSING = "Processing",
  CANCELED = "Canceled",
  ERROR = "Error",
  FAILED = "Failed",
  EXPIRED = "Expired",
}

export enum LINK_ERROR_CODE {
  INVALID_TOKEN = "INVALID_TOKEN",
  LINK_NOT_FOUND = "LINK_NOT_FOUND",
  LINK_EXPIRED = "LINK_EXPIRED",
  LINK_ALREADY_USED = "LINK_ALREADY_USED",
  SESSION_NOT_STARTED = "SESSION_NOT_STARTED",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}
